import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { AppShell } from '~/components/Layout/AppShell.js';

/**
 * Pathless route group `/_auth` — todos os descendentes exigem usuário
 * autenticado. O loader bate em /auth/me e redireciona para /login em 401.
 *
 * Filhos diretos (sem o prefixo `/_auth`): `/_auth/dashboard.tsx` → `/dashboard`.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async () => {
    const res = await fetch('/api/auth/me', { credentials: 'include' });
    if (!res.ok) {
      throw redirect({ to: '/login' });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
